import {html} from 'lit';
import {customElement, state} from 'lit/decorators.js';
import {styles} from './navigation.styles';
import {repeat} from 'lit-html/directives/repeat.js';
import {RouterService} from '../../../services/router.service';
import {LitElementStateful} from '@stefanholzapfel/lit-state';
import {when} from "lit/directives/when.js";
import {State} from '../../loading/loading';
import {classMap} from 'lit-html/directives/class-map.js';
import {UserConfig} from '../../../../../../backend/src/api/queries/user-config.query';
import {NetworkingCapability} from '../../../utils/data.utils';
import {TranslateService} from '../../../services/translate.service';

@customElement('lit-navigation')
export class Navigation extends LitElementStateful<State> {
    static get styles() {
        return [
            styles
        ];
    }

    @state()
    active;

    @state()
    userConfig: UserConfig & NetworkingCapability<'_fetch'>;
    
    buttons = [
        'form',
        'list',
        'detail'
    ]

    constructor(props) {
        super(props);
        this.connectState(['app', 'currentRoute'], 'active');
        this.connectState(['app', 'userConfig'], 'userConfig');
    }


    protected render() {
        return html`
            <div class="station"></div>
            ${
                repeat(this.buttons, null, button => {
                    return when(!RouterService.activeGlobalError && (button === 'form' || this.userConfig?.isAdmin),
                            () => html`<div 
                                    class="${ classMap({
                                        button: true,
                                        'button-active': this.active === `/${button}`
                                    }) }" 
                                    @click="${ () => { this.navigate(`/${button}`)} }">
                                        ${TranslateService.translate(`pages.${button}.button`)}
                                </div>`)
                })
            }
        `;
    }

    navigate(route: string) {
        RouterService.navigate(route);
    }
}
